export default __webpack_public_path__ + "static/beatbugs-2-c-a0d93ce4b4c2a8f6c6a7d8bf87355643.webp";